<template>
  <div class="page-sign-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">未簽收</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
	          style="width: 100%"
	          size="small"
	          placeholder="提貨櫃點"
	          @on-change="handleStoreChange(form.arrive)"
	          v-model="form.arrive"
          >
            <Option
	            :value="item.ReceivingID"
	            v-for="(item, index) in pickAddress"
	            :key="item.ReceivingID"
            >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>

        <FormItem>
          <Select
	          style="width: 100%"
	          size="small"
	          placeholder="貨架號"
	          v-model="form.shelves"
	          ref="resetSelect"
	          clearable
          >
            <Option
	            :value="item.id"
	            v-for="(item, index) in pickShelves"
	            :key="item.id"
            >{{ item.code }}
            </Option>
          </Select>
        </FormItem>

        <FormItem>
          <Select
	          style="width: 100%"
	          size="small"
	          placeholder="公司名稱"
	          v-model="form.order_parent"
	          clearable
          >
            <Option
	            :value="item.id"
	            v-for="(item, index) in samcityType"
	            :key="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>

        <FormItem>
          <Select
	          style="width: 100%"
	          size="small"
	          placeholder="付款狀況"
	          v-model="form.pay_type"
	          clearable
          >
            <Option value="0">未在APP內付款</Option>
            <Option value="1">已在APP內付款</Option>
          </Select>
        </FormItem>

        <FormItem>
          <DatePicker
	          class="no-suffix"
	          type="datetime"
	          size="small"
	          :clearable="false"
	          placeholder="到店起始日期"
	          value-format="yyyy-MM-dd hh:mm:ss"
	          style="width: 100%"
	          :editable="false"
	          v-model="form.start_time"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
	          class="no-suffix"
	          type="datetime"
	          size="small"
	          :clearable="false"
	          placeholder="到店結束日期"
	          value-format="yyyy-MM-dd hh:mm:ss"
	          style="width: 100%"
	          :editable="false"
	          v-model="form.end_time"
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">模糊搜索</label>
          <Input
	          size="small"
	          placeholder="(客戶電話/客戶名稱)"
	          clearable
	          v-model="form.username"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.odd_numbers"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶電話</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.phone"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.sack_number"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
	          <!--<div class="pg-btn style2" @click="handleExport">導出excel</div>-->
            <div class="pg-btn style2" @click="handleExport_zh">
              導出excel-zh
            </div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <!-- <Spin fix class="pg-sub-loading" v-if="isSubmiting">
          <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
          <div class="loading-text">Loading</div>
      </Spin> -->

      <Table
	      ref="table"
	      size="small"
	      border
	      no-data-text="暫無數據"
	      :loading="isSubmiting"
	      @on-selection-change="handleSelectionChange"
	      :columns="table.column"
	      :data="table.data"
      >
        <template slot-scope="{ row, index }" slot="odd_numbers">
          <div class="avatar-box">
            <a class="pg-btn" @click="handleViewOrder(index)">{{
		            row.odd_numbers
	            }}</a>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div
	            class="pg-btn style1"
	            @click="handleViewRemark(index)"
	            v-if="account_permission == 1"
            >
              備註
            </div>
            <div class="pg-btn style3" @click="handleIntegral(index)">
              積分操作
            </div>
            <div class="pg-btn style2" @click="handleViewOrder(index)">
              物流
            </div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
            <span class="total-price">應收款金額：{{ sums }}</span>
            <div class="pg-btn-wrap" style="margin-left: 20px">
              <div class="pg-btn style1" @click="handleSign">收款並簽收</div>
              <div class="pg-btn style2" @click="handleSign_jpoint">
                集金幣簽收
              </div>
              <div class="pg-btn style3" @click="getdrawer">門店未上架清單</div>
            </div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
	                v-model="curPageSize"
	                size="small"
	                placeholder="數量"
	                @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
	                size="small"
	                v-model="pageInput"
	                @on-keyup="handlePageInput"
	                @on-enter="handlePageEnter"
                />
              </div>

              <Page
	              size="small"
	              :current="pageIndex"
	              :page-size="curPageSize"
	              :total="totalCount"
	              @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
      <br/>

      <Drawer
	      width="1200"
	      title="門店未上架清單"
	      :closable="false"
	      v-model="value8"
      >
        <div
	        class="pg-btn-wrap"
	        style="
            font-size: 18px;
            text-align: center;
            margin-bottom: 10px;
            vertical-align: middle;
          "
        >
          門店未上架清單(當日珠海出庫的快遞不會顯示)
        </div>
        <Table
	        size="small"
	        border
	        :loading="isSubmiting_notonshelf"
	        no-data-text="暫無數據"
	        :columns="table_no_shelf.column"
	        :data="table_no_shelf.data"
        >
        </Table>

        <div class="pg-pagger">
          <Row>
            <Col span="11" class="pagger-left">
              <div class="pagger-total">
                總共{{ totalCount_No_Shelf }}條記錄
              </div>
            </Col>
            <Col span="13" class="pagger-right">
              <!-- v-if="totalCount > curPageSize" -->
              <div>
                <Page
	                size="small"
	                :current="pageIndex_No_Shelf"
	                :page-size="curPageSize_No_Shelf"
	                :total="totalCount_No_Shelf"
	                @on-change="handlePageChange_No_Shelf"
                >
                </Page>
                <div class="pagger-sizer">
                  <span>每頁</span>
                  <Select
	                  v-model="curPageSize_No_Shelf"
	                  size="small"
	                  placeholder="數量"
	                  @on-change="handlePageSizeChange_No_Shelf"
                  >
                    <Option :value="10">10</Option>
                    <Option :value="20">20</Option>
                    <Option :value="30">30</Option>
                    <Option :value="40">40</Option>
                    <Option :value="50">50</Option>
                  </Select>
                </div>

                <div class="pagger-elevator">
                  <span>跳轉</span>
                  <Input
	                  size="small"
	                  v-model="pageInput_No_Shelf"
	                  @on-keyup="handlePageInput_No_Shelf"
	                  @on-enter="handlePageEnter_No_Shelf"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Drawer>
    </div>

    <Modal
	    v-model="isShowModalSign"
	    title="收款並簽收"
	    width="650"
	    :footer-hide="true"
	    :mask-closable="!showjuyy"
	    @on-cancel="handleModalSignClose"
    >
      <div class="modal-cont" v-if="!showjuyy">
        <div class="integral-info">
          <Spin fix class="pg-sub-loading" v-if="infoSubmiting">
            <Icon
	            type="ios-loading"
	            :size="20"
	            class="demo-spin-icon-load"
            ></Icon>
            <div class="loading-text">Loading</div>
          </Spin>
          <span
          >餘額積分：<span class="spanco">{{
		          signInfo.integral + signInfo.integralTw
	          }}</span></span
          >
          <span
          >集金幣：<span class="spanco">{{
		          this.signInfo.jpoint
	          }}</span></span
          >
	        <!-- <span>贈送積分：<span class="spanco">{{signInfo.integralTw}}</span></span> -->
          <span
          >總收金額：<span class="spanco">{{
		          this.disCountFn(Number(signInfo.sum))
	          }}</span></span
          >
          <span
          >是否免超期費：<span class="spanco">{{
		          this.signInfo.outtimepay
	          }}</span>
            <span class="span-left">
              <Checkbox
	              class="span-r"
	              size="large"
	              slot="suffix"
	              v-model="checkOutTimePay"
	              @on-change="changeOutTimePay"
              >
              </Checkbox>
            </span>
          </span>
          <span v-if="this.signInfo.pay_status == 0"
          >是否免附加費：<span class="spanco">{{
		          this.signInfo.surcharge_price
	          }}</span>
            <span class="span-left">
              <Checkbox
	              class="span-r"
	              size="large"
	              slot="suffix"
	              v-model="checkAdditional"
	              @on-change="changeAdditional"
              >
              </Checkbox>
            </span>
          </span>
          <span v-if="this.signInfo.delivery == 1"
          >送貨上門費
            <span class="span-left">
              <Checkbox
	              class="span-r"
	              size="large"
	              slot="suffix"
	              v-model="checkOutDelivery"
	              @on-change="changeDelivery"
              >
              </Checkbox>
            </span>
          </span>
          <span
          >門店立減：<span class="spanco">{{
		          this.offline_activity
	          }}</span></span
          >
          <Select
	          v-show="
              userInfos.store_id != 0 &&
              discountList.length &&
              modalForm.credit.isChecked &&
              signInfo.count > 0
            "
	          clearable
	          style="width: 20%"
	          size="small"
	          placeholder="請選擇折扣"
	          v-model="form.discount_num"
          >
            <Option value="">请选择</Option>
            <Option
	            :value="item.discount"
	            v-for="(item, index) in discountList"
	            :key="item.id"
            >{{ item.discount }}折</Option
            >
          </Select>
        </div>

        <Row>
          <Col span="22" pull="1">
            <Form :label-width="150">
              <FormItem v-if="checkOutDelivery">
                <div slot="label" class="form-label">
                  <span>送貨上門費</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.delivery.value"
	                  type="number"
                  ></Input>
                </div>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>積分</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.credit.value"
	                  type="number"
	                  :disabled="!modalForm.credit.isChecked"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="large"
	                    slot="suffix"
	                    v-model="modalForm.credit.isChecked"
	                    @on-change="handleModalChecbox(arguments[0], 'credit')"
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>現金</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.cash.value"
	                  type="number"
	                  :disabled="!modalForm.cash.isChecked"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="large"
	                    slot="suffix"
	                    v-model="modalForm.cash.isChecked"
	                    @on-change="handleModalChecbox(arguments[0], 'cash')"
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>聚應用</span>
                </div>
                <Input
	                v-model="modalForm.juyy.value"
	                type="number"
	                :disabled="!modalForm.juyy.isChecked"
                >
                  <Checkbox
	                  class="input-suffix-cb"
	                  size="large"
	                  slot="suffix"
	                  v-model="modalForm.juyy.isChecked"
	                  @on-change="handleModalChecbox(arguments[0], 'juyy')"
                  ></Checkbox>
                </Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>MPay</span>
                </div>
                <Input
	                v-model="modalForm.mPay.value"
	                type="number"
	                :disabled="!modalForm.mPay.isChecked"
                >
                  <Checkbox
	                  class="input-suffix-cb"
	                  size="large"
	                  slot="suffix"
	                  v-model="modalForm.mPay.isChecked"
	                  @on-change="handleModalChecbox(arguments[0], 'mPay')"
                  ></Checkbox>
                </Input>
              </FormItem>
            </Form>
          </Col>
        </Row>

        <div class="pg-btn-wrap center">
          <div class="pg-btn style1" @click="handlePay">確定</div>
        </div>
      </div>
      <div class="modal-cont" v-else>
        <div style="position: relative">
          <Spin fix class="pg-sub-loading" v-if="infoSubmiting">
            <Icon
	            type="ios-loading"
	            :size="20"
	            class="demo-spin-icon-load"
            ></Icon>
            <div class="loading-text">Loading</div>
          </Spin>
          <Input
	          ref="juyy_ref"
	          :value="juyyCode"
	          :readonly="isPaying"
	          clearable
	          @on-change="change_juyy"
          ></Input>
          <div
	          style="
              font-size: 20px;
              color: #ff466b;
              text-align: center;
              font-weight: bold;
            "
          >
            {{ tiptext }}
          </div>
        </div>
        <div class="pg-btn-wrap center">
          <div class="pg-btn style1" @click="handleCanl(juyyCode)">取消</div>
        </div>
      </div>
    </Modal>

    <Modal
	    v-model="isShowModalSign_jpoint"
	    title="集金幣簽收"
	    width="650"
	    :footer-hide="true"
	    @on-cancel="handleModalSignClose_jpoint"
    >
      <div class="modal-cont">
        <div class="integral-info">
          <Spin fix class="pg-sub-loading" v-if="infoSubmiting">
            <Icon
	            type="ios-loading"
	            :size="20"
	            class="demo-spin-icon-load"
            ></Icon>
            <div class="loading-text">Loading</div>
          </Spin>
	        <!-- <span>餘額積分：<span class="spanco">{{signInfo.integral+signInfo.integralTw}}</span></span> -->
          <span
          >集金幣：<span class="spanco">{{
		          this.signInfo.jpoint
	          }}</span></span
          >
	        <!-- <span>贈送積分：<span class="spanco">{{signInfo.integralTw}}</span></span> -->
          <span
          >總收金額：<span class="spanco">{{
		          Number(signInfo.sum)
	          }}</span></span
          >
          <span
          >是否免超期費：<span class="spanco">{{
		          this.signInfo.outtimepay
	          }}</span>
            <span class="span-left">
              <Checkbox
	              class="span-r"
	              size="large"
	              slot="suffix"
	              v-model="checkOutTimePay_jpoint"
	              @on-change="changeOutTimePay_jpoint"
              >
              </Checkbox>
            </span>
          </span>
          <span v-if="this.signInfo.pay_status == 0"
          >是否免附加費：<span class="spanco">{{
		          this.signInfo.surcharge_price
	          }}</span>
            <span class="span-left">
              <Checkbox
	              class="span-r"
	              size="large"
	              slot="suffix"
	              v-model="checkAdditional_jpoint"
	              @on-change="changeAdditional_jpoint"
              >
              </Checkbox>
            </span>
          </span>
        </div>

        <Row>
          <Col span="22" pull="1">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <span>集金幣</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.jpoint.value"
	                  type="number"
	                  :disabled="!modalForm.jpoint.isChecked"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="large"
	                    slot="suffix"
	                    v-model="modalForm.jpoint.isChecked"
	                    @on-change="
                        handleModalChecbox_jpoint(arguments[0], 'jpoint')
                      "
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
            </Form>
          </Col>
        </Row>

        <div class="pg-btn-wrap center">
          <div class="pg-btn style1" @click="handlePay_jpoint">確定</div>
        </div>
      </div>
    </Modal>

    <Modal
	    v-model="isShowModalSign_goods"
	    title="查詢快件"
	    width="1200"
	    :footer-hide="true"
	    @on-cancel="handleModalSignClose_goods"
    >
      <div class="modal-cont">
        <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
          <Icon
	          type="ios-loading"
	          :size="20"
	          class="demo-spin-icon-load"
          ></Icon>
          <div class="loading-text">Loading</div>
        </Spin>

        <div style="font-weight: bold">快遞信息</div>
        <br/>
        <Table
	        no-data-text=""
	        :columns="table1.column"
	        :data="table1.data"
        ></Table>
        <Table
	        no-data-text=""
	        :columns="table1.column1"
	        :data="table1.data1"
        ></Table>
        <Table
	        no-data-text=""
	        :columns="table1.column2"
	        :data="table1.data2"
        ></Table>
        <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
          <template slot-scope="{ row, index }" slot="status">
            <span v-if="row.status == 0">珠海倉庫-待出庫</span>
            <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
            <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
            <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
            <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
          </template>
        </Table>
        <Table
	        no-data-text=""
	        :columns="table1.column4"
	        :data="table1.data4"
        ></Table>
        <Table
	        no-data-text=""
	        :columns="table1.column5"
	        :data="table1.data5"
        ></Table>
        <br/><br/>
        <div style="font-weight: bold">物流信息</div>
        <br/>
        <div class="step-wrap" v-if="detail && detail.length">
          <div
	          class="step-item clearfix"
	          v-for="(item, index) in detail"
	          :key="item.id"
          >
            <div class="left">
              <div class="l-date">
                <span>{{ item.date }}</span>
                <span>{{ item.week }}</span>
              </div>
              <div class="l-time">{{ item.time }}</div>
            </div>
            <div class="right">
              <div class="r-address">
                {{ item.describe }} , 操作人：{{ item.userinfos }}
              </div>
            </div>
          </div>
        </div>

        <div class="data-null" v-else>
          <!-- <img src="../../../assets/images/null-data.png" alt="" draggable="false"> -->
          <div>暫無數據</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";
import $Utils from "../../../assets/js/utils";
import axios from "axios";
import xlsx from "json-as-xlsx";
import dayjs  from "dayjs";

let controller = new AbortController();
let isthis;
export default {
	name: "ExportCsvPage",
	data() {
		return {
			value8: false,
			successAudio: "music-success.mp3", //成功音效
			errorAudio: "music-fail.mp3", //失敗音效
			pageIndex: 1, //頁碼
			curPageSize: 10, //一頁數量
			pageInput: "", //輸入的頁碼
			totalCount: 1, //總條數
			
			pageIndex_No_Shelf: 1, //頁碼
			curPageSize_No_Shelf: 10, //一頁數量
			pageInput_No_Shelf: "", //輸入的頁碼
			totalCount_No_Shelf: 1, //未上架總條數
			
			pickAddress: [], //提貨櫃點
			pickShelves: [], //貨架號
			samcityType: [], //同城
			account_permission: Store.fetch().type,
			form: {
				arrive: Store.fetch().store_id, //提貨櫃點id
				start_time: "", //起始日期
				end_time: "", //結束日期
				odd_numbers: "", //快遞單號
				phone: "", //電話號碼
				sack_number: "", //袋號
				shelves: "", //貨架號
				username: "", //用户名稱
				pay_type: "",
				order_parent: "",
				discount_num: "",
			},
			offline_activity: "",
			outtimepay: "",
			pay_type: "",
			sums: 0,
			isSubmiting: false,
			isSubmiting_notonshelf: false,
			infoSubmiting: false,
			checkOutTimePay: false,
			additional: "", // 附加費
			checkAdditional: false,
			checkOutDelivery: false,
			checkOutTimePay_jpoint: false,
			checkAdditional_jpoint: false,
			checkOutDelivery_jpoint: false,
			isSubmitingLog: false,
			
			table_no_shelf: {
				column: [
					{
						title: "日期",
						key: "out_time",
						align: "center",
						sortable: true,
						minWidth: 100,
						className: "demo-table-info-column",
					},
					{
						title: "快遞單號",
						key: "odd_numbers",
						align: "center",
						sortable: true,
						minWidth: 150,
						className: "demo-table-info-column",
					},
					/*{
						title: "公司名稱",
						key: "order_parent_name",
						align: "center",
						sortable: true,
						minWidth: 100,
						className: "demo-table-info-column",
					},*/
					{
						title: "門店",
						key: "ReceivingName",
						align: "center",
						sortable: true,
						minWidth: 100,
						className: "demo-table-info-column",
					},
					{
						title: "未上架(日:時間)",
						key: "on_shelf_days",
						align: "center",
						sortable: true,
						minWidth: 100,
						className: "demo-table-info-column",
					},
					{
						title: "備註說明",
						key: "remarks",
						align: "center",
						sortable: true,
						minWidth: 160,
						className: "demo-table-info-column",
					},
				],
				data: [],
			},
			
			table: {
				column: [
					{
						type: "selection",
						width: 60,
						align: "center",
					},
					{
						title: "操作",
						slot: "action",
						align: "center",
						minWidth: 230,
					},
					{
						title: "上架天數",
						key: "save_time",
						align: "center",
						minWidth: 50,
						sortable: true,
					},
					{
						title: "貨架號",
						key: "shelves",
						align: "center",
						minWidth: 130,
						sortable: true,
					},
					{
						title: "同城快件",
						key: "goods_type",
						align: "center",
						minWidth: 150,
						sortable: true,
					},
					{
						title: "客戶名稱【積分】〖集金幣〗",
						key: "recipient_contacts",
						align: "center",
						minWidth: 200,
						sortable: true,
					},
					{
						title: "客戶電話",
						key: "recipient_phone",
						align: "center",
						minWidth: 130,
						sortable: true,
					},
					{
						title: "出貨單號",
						key: "odd_numbers",
						align: "center",
						slot: "odd_numbers",
						minWidth: 150,
						sortable: true,
					},
					{
						title: "付款狀況",
						key: "pay_type",
						align: "center",
						minWidth: 130,
						sortable: true,
					},
					{
						title: "代收費",
						key: "amount",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name",
					},
					{
						title: "到付運費",
						key: "freight_collect",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name",
					},
					{
						title: "加收附加費",
						key: "surcharge_price",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name",
					},
					{
						title: "超期費",
						key: "outtimepay",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name",
					},
					{
						title: "线下立減費",
						key: "offline_activity",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name",
					},
					{
						title: "APP立減費",
						key: "activity",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name",
					},
					{
						title: "合計費用",
						key: "sum",
						align: "center",
						minWidth: 50,
						sortable: true,
						className: "demo-table-info-cell-name-sum",
					},
					{
						title: "取貨櫃點",
						key: "receivingName",
						align: "center",
						minWidth: 150,
					},
					{
						title: "袋號",
						key: "sack_number",
						align: "center",
						sortable: true,
						minWidth: 130,
					},
					{
						title: "品名",
						key: "productName",
						align: "center",
						sortable: true,
						minWidth: 130,
					},
					{
						title: "到店時間",
						key: "arrive_time",
						align: "center",
						sortable: true,
						minWidth: 160,
					},
					{
						title: "備註",
						key: "remarks",
						align: "center",
						sortable: true,
						minWidth: 160,
					},
				],
				data: [],
			},
			
			table1: {
				column: [
					{
						title: "快遞單號",
						key: "order",
						align: "center",
						minWidth: 80,
					},
					{
						title: "客戶電話",
						key: "phone",
						align: "center",
						minWidth: 80,
					},
					{
						title: "客戶名稱",
						key: "username",
						align: "center",
						minWidth: 80,
					},
				],
				column1: [
					{
						title: "重量",
						key: "weight",
						align: "center",
						minWidth: 100,
					},
					{
						title: "尺寸",
						key: "size_sum",
						align: "center",
						minWidth: 100,
					},
					{
						title: "提貨櫃點",
						key: "store",
						align: "center",
						minWidth: 100,
					},
				],
				column2: [
					{
						title: "快件明細",
						key: "detailed",
						align: "center",
						minWidth: 100,
					},
					{
						title: "異常件",
						key: "abnormal",
						align: "center",
						minWidth: 100,
					},
					{
						title: "出庫袋號",
						key: "sack_number",
						align: "center",
						minWidth: 100,
					},
				],
				column3: [
					{
						title: "最新貨態",
						slot: "status",
						align: "center",
						minWidth: 100,
					},
					{
						title: "更新時間",
						key: "created_time",
						align: "center",
						minWidth: 100,
					},
					{
						title: "貨架號",
						key: "shelves",
						align: "center",
						minWidth: 100,
					},
				],
				column4: [
					{
						title: "代收費",
						key: "amount",
						align: "center",
						minWidth: 100,
					},
					{
						title: "附加費",
						key: "surcharge_price",
						align: "center",
						minWidth: 100,
					},
					{
						title: "到附運費",
						key: "freight_collect",
						align: "center",
						minWidth: 100,
					},
				],
				column5: [
					{
						title: "超期費",
						key: "outTime_price",
						align: "center",
						minWidth: 100,
					},
					{
						title: "合計費用",
						key: "total_price",
						align: "center",
						minWidth: 100,
					},
				],
				data: [],
				data1: [],
				data2: [],
				data3: [],
				data4: [],
				data5: [],
			},
			detail: [],
			
			isShowModalSign: false, //收款并签收信息
			isShowModalSign_jpoint: false, //JPOINT收款并签收信息
			isShowModalSign_goods: false, //Goods信息
			
			curCheckedList: [], //当前选中的数据
			signInfo: {},
			
			isPaying: false,
			modalForm: {
				delivery: {
					value: 0,
					isChecked: false,
				},
				credit: {
					value: 0,
					isChecked: true,
				},
				cash: {
					value: 0,
					isChecked: false,
				},
				aomentong: {
					value: 0,
					isChecked: false,
				},
				mPay: {
					value: 0,
					isChecked: false,
				},
				zyPos: {
					value: 0,
					isChecked: false,
				},
				gyPos: {
					value: 0,
					isChecked: false,
				},
				alipay: {
					value: 0,
					isChecked: false,
				},
				wxpay: {
					value: 0,
					isChecked: false,
				},
				jpoint: {
					value: 0,
					isChecked: false,
				},
				juyy: {
					value: 0,
					isChecked: false,
				},
			},
			juyyCode: "",
			juyy_ref: null,
			showjuyy: false,
			tiptext: "",
			csvData: [],
			json_fields: {
				單號: "odd_numbers",
				門店名稱: "ReceivingName",
				總價格: "amount",
				是否立減: "offline_activity",
				手機號: "recipient_phone",
				袋號: "sack_number",
				到付運費: "freight_collect",
				時間: "arrive_time",
			},
			csvFilename: "未簽收報表",
			isLoadExcel: false,
			timeout: null,
			payResult: false,
			setIntervalResult: null,
			discountList: [],
			userInfos: {},
			charge_list: [],
		};
	},
	created() {
		isthis = this;
		this.getPickAddress();
		this.getShelvesList();
		this.getSamcityList();
		this.getdiscountList();
		this.userInfos = localStorage.getItem("jyb_logInfo")
			? JSON.parse(localStorage.getItem("jyb_logInfo"))
			: {};
	},
	mounted() {
		// this.getList();
		// this.getnoshelfList();
	},
	activated() {
		// this.getList();
		// this.getnoshelfList();
	},
	beforeDestroy() {
		clearInterval(this.setIntervalResult);
		this.setIntervalResult = null;
	},
	watch: {
		"form.discount_num": function (oldVal, newVal) {
			console.log(oldVal, newVal);
			this.disCountFn2();
		},
	},
	methods: {
		disCountFn2() {
			let total = this.signInfo.sum;
			let modalForm = this.modalForm;
			
			const discount = Number(this.form.discount_num) || 0;
			
			let sum = total;
			
			if (this.modalForm.credit.isChecked && discount > 0) {
				let total = 0;
				for (const chargeListElement of this.charge_list) {
					if (chargeListElement.amount > 0) {
						total += Math.ceil(chargeListElement.amount * (discount / 10));
					}
				}
				sum = total;
			}
			
			for (const modalFormKey in modalForm) {
				if (modalForm[modalFormKey].isChecked) {
					modalForm[modalFormKey].value = sum;
					break;
				}
			}
			console.log(modalForm);
			this.modalForm = modalForm;
		},
		disCountFn(value) {
			const discount_num = this.form.discount_num;
			const discount = Number(discount_num) || 0;
			const total = Number(value) || 0;
			
			if (this.modalForm.credit.isChecked && discount > 0) {
				let total = 0;
				for (const chargeListElement of this.charge_list) {
					if (chargeListElement.amount > 0) {
						total += Math.ceil(chargeListElement.amount * (discount / 10));
					}
				}
				return total;
			} else {
				return total;
			}
		},
		getdiscountList() {
			this.$Rq
				.requestAuth({
					url: this.$Api.discountList,
					method: "get",
					data: {
						type: 1,
					},
				})
				.then((res) => {
					this.discountList = res.list || [];
				});
		},
		getdrawer() {
			this.value8 = true;
			this.getnoshelfList();
		},
		getSamcityList() {
			const userInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
			this.$Rq
				.requestAuth({
					url: this.$Api.samecityUserList,
					method: "get",
				})
				.then((res) => {
					if (res.code == 0) {
						if (userInfo.user_role == 1) {
							this.samcityType = res.data.data;
						} else {
							this.samcityType = res.data.data.filter(it => it.id == userInfo.parent_id)
						}
						if (this.samcityType.length == 1) {
							this.form.order_parent = this.samcityType[0].id;
						}
					}
				});
		},
		getnoshelfList() {
			let form = this.form;
			this.isSubmiting_notonshelf = true;
			this.$Rq
				.requestAuth({
					url: this.$Api.zhoutList,
					method: "get",
					data: {
						offset: (this.pageIndex_No_Shelf - 1) * this.curPageSize_No_Shelf,
						limit: this.curPageSize_No_Shelf,
						start_time: this.$Utils.formatDate(form.start_time),
						end_time: this.$Utils.formatDate(form.end_time),
						arrive: form.arrive || '',
						status: 1,
						goods_type: 0,
						
						// order_parent: form.order_parent,
						// odd_numbers: form.odd_numbers,
					},
				})
				.then((res) => {
					this.isSubmiting_notonshelf = false;
					if (res.code == 0) {
						let tempArr = [];
						let resData = res.data.data;
						
						for (let i = 0; i < resData.length; i++) {
							const givenTime = resData[i].out_time || dayjs();
							// 当前时间
							const now = dayjs();

							// 计算时间差
							const diff = dayjs(givenTime).diff(now);
							// 将差值转换为天和小时
							// 计算绝对值
							const absDiff = Math.abs(diff);

							// 将差值转换为天和小时
							const days = Math.floor(absDiff / (1000 * 60 * 60 * 24)); // 计算天数
							const hours = Math.floor((absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 计算小时
							
							tempArr.push({
								remarks:
									resData[i].remarks == null ? "- - -" : resData[i].remarks,
								order_parent_name:
									resData[i].order_parent_name == null
										? "---"
										: resData[i].order_parent_name,
								out_time: resData[i].out_time,
								odd_numbers: resData[i].odd_numbers,
								ReceivingName: resData[i]?.store?.ReceivingName,
								on_shelf_days:`${days}天${hours}小時`,
							});
						}
						
						this.totalCount_No_Shelf = res.data.count;
						this.table_no_shelf.data = tempArr;
					}
				})
				.catch((err) => {
					// this.isLoading = false;
					this.isSubmiting_notonshelf = false;
				});
		},
		handleViewOrder(index) {
			this.isShowModalSign_goods = true;
			this.isSubmitingLog = true;
			let tableData = this.table.data;
			
			this.$Rq
				.requestAuth({
					url: this.$Api.all_search,
					method: "get",
					data: {
						order: tableData[index].odd_numbers,
					},
				})
				.then((res) => {
					this.isSubmitingLog = false;
					let tempArr = [];
					let tempArr1 = [];
					let tempArr2 = [];
					let tempArr3 = [];
					let tempArr4 = [];
					let tempArr5 = [];
					let resData = res.data;
					
					if (res.code == 0) {
						for (let i = 0; i < resData.data.length; i++) {
							tempArr.push({
								order: resData.data[i].order,
								username: resData.data[i].username,
								phone: resData.data[i].phone,
							});
							
							tempArr1.push({
								weight: resData.data[i].weight,
								size_sum:
									resData.data[i].long +
									"x" +
									resData.data[i].width +
									"x" +
									resData.data[i].height,
								store:
									resData.data[i].store == null
										? "- - -"
										: resData.data[i].store.ReceivingName,
							});
							
							tempArr2.push({
								sack_number: resData.data[i].sack_number,
								detailed:
									resData.data[i].detailed == null
										? "- - -"
										: resData.data[i].detailed.name,
								abnormal: resData.data[i].abnormal == 0 ? "否" : "是",
							});
							
							tempArr3.push({
								shelves:
									resData.data[i].shelves == null
										? "- - -"
										: resData.data[i].shelves.code,
								status: resData.data[i].status,
								created_time: resData.data[i].created_time,
							});
							
							tempArr4.push({
								amount: resData.data[i].amount,
								surcharge_price: resData.data[i].surcharge_price,
								freight_collect: resData.data[i].freight_collect,
							});
							
							tempArr5.push({
								outTime_price: resData.data[i].outTime_price,
								total_price:
									Number(resData.data[i].surcharge_price) +
									Number(resData.data[i].outTime_price) +
									Number(resData.data[i].freight_collect) +
									Number(resData.data[i].amount),
							});
						}
						this.table1.data = tempArr;
						this.table1.data1 = tempArr1;
						this.table1.data2 = tempArr2;
						this.table1.data3 = tempArr3;
						this.table1.data4 = tempArr4;
						this.table1.data5 = tempArr5;
					}
				})
				.catch((err) => {
					this.isSubmitingLog = false;
				});
			
			this.isSubmitingLog = true;
			this.$Rq
				.requestAuth({
					url: this.$Api.logisticsInfo + "/" + tableData[index].odd_numbers,
					method: "get",
					data: {},
				})
				.then((res) => {
					this.isSubmitingLog = false;
					if (res.code == 0) {
						let resData = res.data;
						let tempArr = [];
						let userinfo;
						
						for (let i = 0; i < resData.length; i++) {
							let datetime = this.getDateTime(resData[i].created_at);
							
							if (resData[i].userinfos == null) {
								if (resData[i].remarks.match(/[\u606d\u559c\u60a8]/g)) {
									userinfo = "用戶線上支付";
								} else {
									if (resData[i].admin_name != null) {
										userinfo = resData[i].admin_name;
									} else {
										userinfo = "智能櫃派送員";
									}
								}
							} else {
								userinfo = resData[i].userinfos.username;
							}
							
							tempArr.push({
								userinfos: userinfo,
								id: resData[i].id,
								date: datetime.date,
								week: datetime.week,
								time: datetime.time,
								describe: resData[i].remarks,
							});
						}
						
						this.detail = tempArr;
					}
				})
				.catch((err) => {
					this.isSubmitingLog = false;
				});
		},
		handleViewRemark(index) {
			let tableData = this.table.data;
			this.$router.push({
				path: "/shopSignetodoRemark?id=" + tableData[index].remark_id,
			});
		},
		
		getDateTime(datetime) {
			let date = new Date(datetime);
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDate();
			let hour = date.getHours();
			let minute = date.getMinutes();
			let second = date.getSeconds();
			let week = date.getDay();
			let weekList = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
			
			return {
				date: `${this.formateNum_log(year)}-${this.formateNum_log(
					month
				)}-${this.formateNum_log(day)}`,
				time: `${this.formateNum_log(hour)}:${this.formateNum_log(
					minute
				)}:${this.formateNum_log(second)}`,
				week: weekList[week],
			};
		},
		
		formateNum_log(num) {
			return num > 9 ? num : "0" + num;
		},
		formatDate(datetime) {
			if (!datetime) return "";
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
				date
			)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
				milliseconds
			)}`;
		},
		formatNum(num) {
			return num < 10 ? "0" + num : num;
		},
		getPickAddress() { //提貨櫃點
			this.$Rq
				.requestAuth({
					url: this.$Api.pickAddress,
					method: "get",
					data: {
						company_id: 0,
					},
				})
				.then((res) => {
					if (res.code == 0) {
						this.pickAddress = res.data.data.filter(it=>it.company_id != 15);
						if (res.data.data.length <= 1) {
							this.form.arrive = res.data?.data[0]?.ReceivingID;
						}
					}
				});
		},
		getShelvesList(
			list //貨架號
		) {
			if (list > 0) {
				this.$Rq
					.requestAuth({
						url: this.$Api.shelvesAllList,
						method: "get",
						data: {
							store_id: list,
						},
					})
					.then((res) => {
						if (res.code == 0) {
							this.pickShelves = res.data;
						}
					});
			} else {
				this.$Rq
					.requestAuth({
						url: this.$Api.shelvesAllList,
						method: "get",
						data: {
							store_id: Store.fetch().store_id,
						},
					})
					.then((res) => {
						if (res.code == 0) {
							this.pickShelves = res.data;
						}
					});
			}
		},
		arrive_time_count(date1) {
			var date1 = date1;
			var date2 = new Date();
			var date3 = date2.getTime() - new Date(date1).getTime();
			var subMinutes = Math.floor(date3 / (60 * 1000));
			var days = Math.floor(date3 / (24 * 3600 * 1000));
			var leave1 = date3 % (24 * 3600 * 1000);
			var hours = Math.floor(leave1 / (3600 * 1000));
			var leave2 = leave1 % (3600 * 1000);
			var minutes = Math.floor(leave2 / (60 * 1000));
			var leave3 = leave2 % (60 * 1000);
			var seconds = Math.round(leave3 / 1000);
			return days;
		},
		handleStoreChange(index) {
			this.$refs.resetSelect.clearSingleSelect();
			this.getShelvesList(index);
		},
		getList() {
			let form = this.form;
			this.isSubmiting = true;
			this.totalCount = 0;
			this.table.data = [];
			this.$Rq
				.requestAuth({
					url: this.$Api.goodsPs,
					method: "get",
					data: {
						status: 3,
						offset: (this.pageIndex - 1) * this.curPageSize,
						limit: this.curPageSize,
						arrive: form.arrive,
						start_time: this.formatDate(form.start_time),
						end_time: this.formatDate(form.end_time),
						odd_numbers: form.odd_numbers,
						phone: form.phone,
						sack_number: form.sack_number,
						username: form.username,
						pay_type: form.pay_type,
						arrive_code: form.shelves,
						order_parent: form.order_parent,
					},
				})
				.then((res) => {
					this.isSubmiting = false;
					if (res.code == 0) {
						let tempArr = [];
						let class_temp = [];
						let class_pay_type = [];
						let samecity;
						let resData = res.data.data;
						let amount_count;
						
						for (let i = 0; i < resData.length; i++) {
							let integral_tw = 0;
							if (resData[i].user != null) {
								for (let j = 0; j < resData[i].user.tw.length; j++) {
									let integral_tw_count = Number(
										resData[i].user.tw[j].integral
									);
									integral_tw += integral_tw_count;
								}
							}
							
							if (resData[i].pay_type == 0) {
								class_pay_type[i] = "";
							} else {
								class_pay_type[i] = "demo-table-app-row";
							}
							
							if (this.arrive_time_count(resData[i].arrive_time) >= 7) {
								class_temp[i] = "demo-table-info-row";
							} else if (this.arrive_time_count(resData[i].arrive_time) >= 2) {
								class_temp[i] = "demo-table-error-row";
							} else {
								class_temp[i] = "";
							}
							
							if (resData[i].goods_type == 2) {
								if (resData[i].type == 1) {
									amount_count = Number(resData[i].amount);
								}
								if (resData[i].type == 2) {
									amount_count = Number(0);
								}
								if (resData[i].type == 3) {
									amount_count = Number(0);
								}
								
								if (resData[i].pay_type == 0) {
									samecity = "未在APP內付款";
								} else {
									samecity = "已在APP內付款";
								}
							} else {
								amount_count = Number(resData[i].amount);
								
								if (resData[i].pay_type == 0) {
									samecity = "未在APP內付款";
								} else {
									samecity = "已在APP內付款";
								}
							}
							
							let type;
							
							if (resData[i].type == 1) {
								type = "收方付費";
							} else if (resData[i].type == 2) {
								type = "商家餘額";
							} else if (resData[i].type == 3) {
								type = "商家月結";
							}
							
							tempArr.push({
								remark_id: resData[i].id,
								
								user_id:
									resData[i].user == null ? "- - -" : resData[i].user.user_id,
								
								recipient_contacts:
									resData[i].user == null
										? resData[i].recipient_contacts
										: resData[i].recipient_contacts +
										"【" +
										(resData[i].user.user_integral + integral_tw) +
										"】" +
										"〖" +
										(resData[i].user.jpoint == null
											? 0
											: Number(resData[i].user.jpoint / 100)) +
										"〗", //客戶名稱【積分】
								
								jpoint:
									resData[i].user.jpoint == null
										? 0
										: Number(resData[i].user.jpoint / 100),
								
								recipient_phone: resData[i].recipient_phone, //客戶電話
								
								odd_numbers: resData[i].odd_numbers, //出貨單號
								
								shelves:
									resData[i].shelves == null
										? "- - -"
										: resData[i].shelves.code, //貨架號
								
								// pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //付款状况
								
								pay_type: samecity,
								
								sum:
									amount_count +
									Number(resData[i].freight_collect) +
									Number(resData[i].surcharge_price) +
									Number(resData[i].outtimepays || 0) -
									Number(
										resData[i].orderamount == null
											? 0
											: resData[i].orderamount.discount
									), //合計費用
								
								freight_collect: Number(resData[i].freight_collect), // 到付運費
								
								surcharge_price: Number(resData[i].surcharge_price), // 加收附加費
								
								outtimepay: resData[i].outtimepays ? resData[i].outtimepays : 0, //超期費
								
								amount: amount_count, // 代收費
								
								offline_activity:
									resData[i].store == null
										? 0
										: "-" + resData[i].store.offline_activity, // 門店立減費
								
								activity:
									resData[i].store == null
										? 0
										: "-" + resData[i].store.activity, // app立減費
								
								receivingName:
									resData[i].store == null
										? "- - -"
										: resData[i].store.ReceivingName, //取貨櫃點
								
								sack_number: resData[i].sack_number, //袋號
								
								productName: resData[i].detailed.name, //品名
								
								arrive_time: resData[i].arrive_time, // 到店時間
								
								remarks:
									resData[i].remarks == null ? "- - -" : resData[i].remarks, //備註
								
								goods_type:
									resData[i].goods_type != 2 ? "否" : "是" + " (" + type + ")", //同城類型
								
								save_time: this.arrive_time_count(resData[i].arrive_time),
								cellClassName: {
									//記錄
									save_time: class_temp[i],
									pay_type: class_pay_type[i],
								},
							});
						}
						this.totalCount = res.data.count;
						this.table.data = tempArr;
					} else {
						this.showTipInfo(res.msg);
					}
				})
				.catch((err) => {
					this.isSubmiting = false;
				});
		},
		getSignInfo() { //签收获取积分和收款金额
			this.isSubmiting = true;
			
			let odd_numbers = this.curCheckedList.map((item, index) => {
				return item.odd_numbers;
			});
			let amount = this.curCheckedList.map((item, index) => {
				return item.amount;
			});
			let offline_activity = this.curCheckedList.map((item, index) => {
				return item.offline_activity;
			});
			let outtimepay = this.curCheckedList.map((item, index) => {
				return item.outtimepay;
			});
			let pay_type = this.curCheckedList.map((item, index) => {
				return item.pay_type;
			});
			
			this.$Rq
				.requestAuth({
					url: this.$Api.getSignInfo,
					method: "post",
					data: {
						odd_numbers,
						amount,
					},
				})
				.then((res) => {
					this.isSubmiting = false;
					
					if (res.code == 0) {
						for (var i = 0; i < pay_type.length; i++) {
							if (pay_type[0] != pay_type[i]) {
								this.$Modal.error({
									title: "警告",
									content: "不能混合簽收",
								});
								return;
							} else {
								var pay_type_condition = true;
							}
						}
						
						if (pay_type_condition == true) {
							if (res.data.pay_status === 1) {
								console.log(res.data.pay_status);
								this.signInfo = res.data;
								this.offline_activity = res.data.discount;
								
								var sum_offline_activity = 0;
								for (let i = 0; i < offline_activity.length; i++) {
									sum_offline_activity += Math.abs(offline_activity[i]);
								}
								this.signInfo.pay_status = res.data.pay_status;
								this.signInfo.offline_activity = res.data.discount;
								this.signInfo.sum = res.data.amount + res.data.outtimepay; //總費用 = 代收費+超期費+到附運費+立減3元
								this.signInfo.outtimepay = res.data.outtimepay || 0; //超期費
								this.signInfo.surcharge_price = res.data.surcharge_price || 0; //附加費
								this.signInfo.integralTw = res.data.integralTw || 0;
								this.signInfo.count = res.data.amount; //代收費+到附運費
								this.signInfo.delivery = res.data.delivery;
								this.signInfo.pay_status = res.data.pay_status;
								this.charge_list = res.data.charge_list;
								
								if (this.signInfo.sum > this.signInfo.integral) {
									this.modalForm.cash.value = Number(this.signInfo.sum);
									this.modalForm.cash.isChecked = true;
									this.modalForm.credit.isChecked = false;
								} else {
									this.modalForm.credit.value = Number(this.signInfo.sum);
									this.modalForm.credit.isChecked = true;
									this.modalForm.cash.isChecked = false;
								}
								this.handleModalSignShow();
							}
							
							if (res.data.pay_status === 0) {
								this.signInfo = res.data;
								this.offline_activity = res.data.discount; //立减
								
								var sum_offline_activity = 0;
								for (let i = 0; i < offline_activity.length; i++) {
									sum_offline_activity += Math.abs(offline_activity[i]);
								}
								
								this.signInfo.pay_status = res.data.pay_status;
								this.signInfo.offline_activity = res.data.discount; //立减
								this.signInfo.sum =
									res.data.amount +
									res.data.outtimepay +
									res.data.surcharge_price -
									this.signInfo.offline_activity; //總費用 = 代收費 + 超期費 + 到附運費 + 立減3元
								this.signInfo.outtimepay = res.data.outtimepay || 0; //超期費
								this.signInfo.surcharge_price = res.data.surcharge_price || 0; //附加費
								this.signInfo.count = res.data.amount; //代收費 + 到附運費
								
								this.signInfo.integralTw = res.data.integralTw || 0;
								this.signInfo.delivery = res.data.delivery;
								this.signInfo.pay_status = res.data.pay_status;
								this.charge_list = res.data.charge_list;
								
								if (this.signInfo.sum > this.signInfo.integral) {
									this.modalForm.cash.value = Number(this.signInfo.sum);
									this.modalForm.cash.isChecked = true;
									this.modalForm.credit.isChecked = false;
								} else {
									this.modalForm.credit.value = Number(this.signInfo.sum);
									this.modalForm.credit.isChecked = true;
									this.modalForm.cash.isChecked = false;
								}
								this.handleModalSignShow();
							}
						}
					}
				})
				.catch((err) => {
					this.isSubmiting = false;
				});
		},
		getSignInfo_jpoint() { //签收获取积分和收款金额
			this.isSubmiting = true;
			
			let odd_numbers = this.curCheckedList.map((item, index) => {
				return item.odd_numbers;
			});
			let amount = this.curCheckedList.map((item, index) => {
				return item.amount;
			});
			let offline_activity = this.curCheckedList.map((item, index) => {
				return item.offline_activity;
			});
			let outtimepay = this.curCheckedList.map((item, index) => {
				return item.outtimepay;
			});
			let pay_type = this.curCheckedList.map((item, index) => {
				return item.pay_type;
			});
			
			this.$Rq
				.requestAuth({
					url: this.$Api.getSignInfo,
					method: "post",
					data: {
						odd_numbers,
						amount,
					},
				})
				.then((res) => {
					this.isSubmiting = false;
					
					if (res.code == 0) {
						for (var i = 0; i < pay_type.length; i++) {
							if (pay_type[0] != pay_type[i]) {
								this.$Modal.error({
									title: "警告",
									content: "不能混合簽收",
								});
								return;
							} else {
								var pay_type_condition = true;
							}
						}
						
						if (pay_type_condition == true) {
							if (res.data.pay_status === 1) {
								this.signInfo = res.data;
								this.offline_activity = offline_activity[0];
								
								var sum_offline_activity = 0;
								for (let i = 0; i < offline_activity.length; i++) {
									sum_offline_activity += Math.abs(offline_activity[i]);
								}
								
								this.signInfo.pay_status = res.data.pay_status;
								this.signInfo.offline_activity = sum_offline_activity;
								this.signInfo.sum =
									res.data.amount + res.data.outtimepay + sum_offline_activity; //總費用 = 代收費+超期費+到附運費+立減3元
								this.signInfo.outtimepay = res.data.outtimepay || 0; //超期費
								this.signInfo.surcharge_price = res.data.surcharge_price || 0; //附加費
								this.signInfo.integralTw = res.data.integralTw || 0;
								this.signInfo.count = res.data.amount; //代收費+到附運費
								this.signInfo.delivery = res.data.delivery;
								this.signInfo.pay_status = res.data.pay_status;
								this.modalForm.jpoint.value = Number(this.signInfo.sum);
								console.log(this.modalForm.jpoint.value);
								this.modalForm.jpoint.isChecked = true;
								this.handleModalSignShow_Jpoint();
							}
							
							if (res.data.pay_status === 0) {
								this.signInfo = res.data;
								this.offline_activity = offline_activity[0];
								
								console.log(offline_activity);
								
								var sum_offline_activity = 0;
								for (let i = 0; i < offline_activity.length; i++) {
									sum_offline_activity += Math.abs(offline_activity[i]);
								}
								console.log(sum_offline_activity);
								this.signInfo.pay_status = res.data.pay_status;
								this.signInfo.offline_activity = sum_offline_activity;
								this.signInfo.sum =
									res.data.amount +
									res.data.outtimepay +
									res.data.surcharge_price; //總費用 = 代收費 + 超期費 + 到附運費 + 立減3元
								this.signInfo.outtimepay = res.data.outtimepay || 0; //超期費
								this.signInfo.surcharge_price = res.data.surcharge_price || 0; //附加費
								this.signInfo.count = res.data.amount; //代收費 + 到附運費
								this.signInfo.integralTw = res.data.integralTw || 0;
								this.signInfo.delivery = res.data.delivery;
								this.signInfo.pay_status = res.data.pay_status;
								this.modalForm.jpoint.value = Number(this.signInfo.sum);
								console.log(this.modalForm.jpoint.value);
								this.modalForm.jpoint.isChecked = true;
								this.handleModalSignShow_Jpoint();
							}
						}
					}
				})
				.catch((err) => {
					this.isSubmiting = false;
				});
		},
		handleViewWuliu(index) {
			let tableData = this.table.data;
			this.$router.push({
				path:
					"/shopSigntodologisticsInfo?orderNo=" + tableData[index].odd_numbers,
			});
		},
		handleIntegral(index) {
			let tableData = this.table.data;
			// console.log(tableData[index].user_id);
			this.$router.push({
				path: "/shopUserIntegral?id=" + tableData[index].user_id,
			});
		},
		handleSearch() {
			this.pageIndex = 1;
			this.pageIndex_No_Shelf = 1;
			isthis.sums = 0;
			this.getList();
			// this.getnoshelfList();
		},
		handleExport() {
			let token = localStorage.getItem("jyb_token");
			let form = this.form;
			let params = {
				Authorization: token,
				status: 3, //0待出库, 1已出库
				odd_numbers: form.odd_numbers,
				sack_number: form.sack_number,
				phone: form.phone,
				arrive: form.arrive,
				username: form.username,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time),
			};
			let formatParams = this.$Utils.formateObjToParamStr(params);
			if (form.start_time == "") {
				this.$Utils.showTipInfo("請選擇起始時間");
			} else if (form.end_time == "") {
				this.$Utils.showTipInfo("請選擇结束時間");
			} else {
				this.getList();
				this.getnoshelfList();
				window.open(`${this.$Api.deliverExport_new}?${formatParams}`, "_blank");
			}
		},
		filterCon(val) {
			let count,
				sum = 0,
				i = 0;
			
			for (i; i < val.length; i++) {
				const amount = val[i].amount || 0;
				sum = sum + parseFloat(amount);
			}
			return {
				count: i,
				sum,
			};
		},
		handleExport_zh() {
			if (this.isLoadExcel) {
				return this.$Utils.showTipInfo("正在下載報表，請稍等");
			}
			let token = localStorage.getItem("jyb_token");
			let form = this.form;
			
			if (!form.start_time || !form.end_time) {
				return this.$Utils.showTipInfo("请选择导出时间");
			}
			
			this.isSubmiting = true;
			this.isLoadExcel = true;
			const datas = {
				status: 3, //0待出库, 1已出库
				odd_numbers: form.odd_numbers,
				sack_number: form.sack_number,
				phone: form.phone,
				arrive: form.arrive,
				username: form.username,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time),
			};
			if (form.arrive == 0) {
				delete datas.arrive;
			}
			
			this.$Rq
				.requestAuth({
					url: this.$Api.deliverExport_new_zh,
					method: "get",
					data: datas,
				})
				.then(async (res) => {
					console.log(res);
					
					if (res.code === 0) {
						const data = res.data.data.map((item) => {
							const freight_collect = item.freight_collect;
							const discount = item.discount;
							item.freight_collect = parseFloat(freight_collect) || 0;
							item.discount = parseFloat(discount) || 0;
							return item;
						});
						const table = [
							{
								sheet: "未簽收明細",
								columns: [
									{label: "單號", value: "odd_numbers"},
									{label: "門店名稱", value: "ReceivingName"},
									{label: "總價格", value: "amount"},
									{label: "是否立減", value: "offline_activity"},
									{label: "手機號", value: "recipient_phone"},
									{label: "袋號", value: "sack_number"},
									{label: "到付運費", value: "freight_collect"},
									{label: "時間", value: "arrive_time"},
								],
								content: data,
							},
							{
								sheet: "未簽收總覽",
								columns: [
									{label: "縂件數", value: "count"},
									{label: "縂金額", value: "sum"},
								],
								content: [
									{
										count: this.filterCon(data).count,
										sum: this.filterCon(data).sum,
									},
								],
							},
						];
						xlsx(table, {
							fileName: this.csvFilename,
							extraLength: 3,
							writeMode: "writeFile",
							writeOptions: {},
							RTL: false,
						});
						this.isSubmiting = false;
						this.isLoadExcel = false;
					} else {
						this.$message.error(res);
						this.isSubmiting = false;
						this.isLoadExcel = false;
					}
				})
				.catch((e) => {
					console.log(e);
					this.$message.error("網絡異常");
					this.isSubmiting = false;
					this.isLoadExcel = false;
				});
		},
		handleModalSignShow() { //收款並簽收弹窗显示隐藏
			this.isShowModalSign = true;
		},
		handleModalSignShow_Jpoint() { //收款並簽收弹窗显示隐藏
			this.isShowModalSign_jpoint = true;
		},
		
		handleModalSignClose_goods() {
			this.isShowModalSign_goods = false;
		},
		handleModalSignClose_jpoint() {
			let modalForm = this.modalForm;
			for (let key in modalForm) {
				modalForm[key].isChecked = false;
				modalForm[key].value = "";
			}
			this.checkAdditional_jpoint = false;
			this.checkOutTimePay_jpoint = false;
			this.checkOutDelivery_jpoint = false;
			this.isShowModalSign_jpoint = false;
		},
		handleModalChecbox(value, field) {
			let modalForm = this.modalForm;
			this.form.discount_num = 0;
			console.log(this.form.discount_num);
			for (let key in modalForm) {
				modalForm[key].isChecked = false;
			}
			
			modalForm[field].isChecked = value;
			this.modalForm = modalForm;
			
			for (let key in modalForm) {
				if (modalForm[key].isChecked == false) {
					modalForm[key].value = 0;
				} else {
					modalForm[key].isChecked = true;
					modalForm[key].value = this.signInfo.sum;
				}
			}
		},
		
		handleModalChecbox_jpoint(value, field) {
			let modalForm = this.modalForm;
			
			for (let key in modalForm) {
				modalForm[key].isChecked = false;
			}
			
			modalForm[field].isChecked = value;
			this.modalForm = modalForm;
			
			for (let key in modalForm) {
				if (modalForm[key].isChecked == false) {
					modalForm[key].value = 0;
				} else {
					modalForm[key].isChecked = true;
					modalForm[key].value = this.signInfo.sum;
				}
			}
		},
		handleSign() { //收款並簽收
			if (!this.table.data.length) {
				this.$Utils.showTipInfo("暂時沒有數據");
				return;
			}
			
			this.curCheckedList = this.$refs.table.getSelection();
			if (!this.curCheckedList.length) {
				this.$Utils.showTipInfo("請先勾選數據");
				return;
			}
			
			this.getSignInfo();
		},
		handleSign_jpoint() { //收款並簽收
			if (!this.table.data.length) {
				this.$Utils.showTipInfo("暂時沒有數據");
				return;
			}
			
			this.curCheckedList = this.$refs.table.getSelection();
			if (!this.curCheckedList.length) {
				this.$Utils.showTipInfo("請先勾選數據");
				return;
			}
			
			this.getSignInfo_jpoint();
		},
		changeAdditional() {
			let modalForm = this.modalForm;
			if (this.checkAdditional) {
				if (this.checkOutTimePay) {
					console.log("免附加费+免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count - this.signInfo.offline_activity
								);
								// console.log(Number(this.signInfo.count));
							}
						}
					}
					if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum = Number(
							this.signInfo.count - this.signInfo.offline_activity
						);
					}
				} else {
					console.log("免附加费+不免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (
								this.signInfo.count +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value == 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity
								);
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.outtimepay -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity;
					}
				}
			} else {
				if (this.checkOutTimePay) {
					console.log("不免附加费+免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (
								this.signInfo.count +
								this.signInfo.surcharge_price -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count +
									this.signInfo.surcharge_price -
									this.signInfo.offline_activity
								);
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.surcharge_price -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.surcharge_price -
							this.signInfo.offline_activity;
					}
				} else {
					console.log("不免附加费+不免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (
								this.signInfo.count +
								this.signInfo.surcharge_price +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count +
									this.signInfo.surcharge_price +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity
								);
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.surcharge_price +
						this.signInfo.outtimepay -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.surcharge_price +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity;
					}
				}
			}
		},
		changeOutTimePay() {
			let modalForm = this.modalForm;
			if (this.checkOutTimePay) {
				if (this.checkAdditional) {
					console.log("免超时费+免附加费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (
								Number(this.signInfo.count - this.signInfo.offline_activity) <=
								0
							) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count - this.signInfo.offline_activity
								);
							}
						}
					}
					if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum = Number(
							this.signInfo.count - this.signInfo.offline_activity
						);
					}
				} else {
					console.log("免超时费+不免附加费");
					
					if (this.signInfo.pay_status == 1) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count - this.signInfo.offline_activity
									);
								}
							}
						}
						if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum = Number(
								this.signInfo.count - this.signInfo.offline_activity
							);
						}
					}
					
					if (this.signInfo.pay_status == 0) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (
									this.signInfo.count +
									this.signInfo.surcharge_price -
									this.signInfo.offline_activity <=
									0
								) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count +
										this.signInfo.surcharge_price -
										this.signInfo.offline_activity
									);
								}
							}
						}
						if (
							this.signInfo.count +
							this.signInfo.surcharge_price -
							this.signInfo.offline_activity <=
							0
						) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum = Number(
								this.signInfo.count +
								this.signInfo.surcharge_price -
								this.signInfo.offline_activity
							);
						}
					}
				}
			} else {
				if (this.checkAdditional) {
					console.log("不免超时费+免附加费");
					
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (
								this.signInfo.count +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity
								);
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.outtimepay -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity;
					}
				} else {
					console.log("不免超时费+不免附加费");
					
					if (this.signInfo.pay_status == 1) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count + this.signInfo.outtimepay
									);
								}
							}
						}
						if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum =
								this.signInfo.count + this.signInfo.outtimepay;
						}
					}
					
					if (this.signInfo.pay_status == 0) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (
									this.signInfo.count +
									this.signInfo.surcharge_price +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity <=
									0
								) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count +
										this.signInfo.surcharge_price +
										this.signInfo.outtimepay -
										this.signInfo.offline_activity
									);
								}
							}
						}
						if (
							this.signInfo.count +
							this.signInfo.surcharge_price +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity <=
							0
						) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum =
								this.signInfo.count +
								this.signInfo.surcharge_price +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity;
						}
					}
				}
			}
		},
		changeDelivery() {
			let modalForm = this.modalForm;
			if (this.checkOutDelivery) {
				this.modalForm.delivery.value = 0;
			} else {
				this.modalForm.delivery.value = 0;
			}
		},
		changeAdditional_jpoint() {
			let modalForm = this.modalForm;
			if (this.checkAdditional_jpoint) {
				if (this.checkOutTimePay_jpoint) {
					console.log("免附加费+免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (this.signInfo.count <= 0) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(this.signInfo.count);
								// console.log(Number(this.signInfo.count));
							}
						}
					}
					if (this.signInfo.count <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum = Number(this.signInfo.count);
					}
				} else {
					console.log("免附加费+不免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
								modalForm[key].value == 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count + this.signInfo.outtimepay
								);
							}
						}
					}
					if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum = this.signInfo.count + this.signInfo.outtimepay;
					}
				}
			} else {
				if (this.checkOutTimePay_jpoint) {
					console.log("不免附加费+免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (this.signInfo.count + this.signInfo.surcharge_price <= 0) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count + this.signInfo.surcharge_price
								);
							}
						}
					}
					if (this.signInfo.count + this.signInfo.surcharge_price <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum =
							this.signInfo.count + this.signInfo.surcharge_price;
					}
				} else {
					console.log("不免附加费+不免超时费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (
								this.signInfo.count +
								this.signInfo.surcharge_price +
								this.signInfo.outtimepay <=
								0
							) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count +
									this.signInfo.surcharge_price +
									this.signInfo.outtimepay
								);
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.surcharge_price +
						this.signInfo.outtimepay <=
						0
					) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.surcharge_price +
							this.signInfo.outtimepay;
					}
				}
			}
		},
		changeOutTimePay_jpoint() {
			let modalForm = this.modalForm;
			if (this.checkOutTimePay_jpoint) {
				if (this.checkAdditional_jpoint) {
					console.log("免超时费+免附加费");
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (Number(this.signInfo.count) <= 0) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(this.signInfo.count);
							}
						}
					}
					if (this.signInfo.count <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum = Number(this.signInfo.count);
					}
				} else {
					console.log("免超时费+不免附加费");
					
					if (this.signInfo.pay_status == 1) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (this.signInfo.count <= 0) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(this.signInfo.count);
									console.log(modalForm[key].value);
								}
							}
						}
						if (this.signInfo.count <= 0) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum = Number(this.signInfo.count);
						}
					}
					
					if (this.signInfo.pay_status == 0) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (this.signInfo.count + this.signInfo.surcharge_price <= 0) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count + this.signInfo.surcharge_price
									);
								}
							}
						}
						if (this.signInfo.count + this.signInfo.surcharge_price <= 0) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum = Number(
								this.signInfo.count + this.signInfo.surcharge_price
							);
						}
					}
				}
			} else {
				if (this.checkAdditional_jpoint) {
					console.log("不免超时费+免附加费");
					
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0;
						} else {
							if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
								modalForm[key].value = 0;
							} else {
								modalForm[key].value = Number(
									this.signInfo.count + this.signInfo.outtimepay
								);
							}
						}
					}
					if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
						this.signInfo.sum = 0;
					} else {
						this.signInfo.sum = this.signInfo.count + this.signInfo.outtimepay;
					}
				} else {
					console.log("不免超时费+不免附加费");
					
					if (this.signInfo.pay_status == 1) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count + this.signInfo.outtimepay
									);
								}
							}
						}
						if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum =
								this.signInfo.count + this.signInfo.outtimepay;
						}
					}
					
					if (this.signInfo.pay_status == 0) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0;
							} else {
								if (
									this.signInfo.count +
									this.signInfo.surcharge_price +
									this.signInfo.outtimepay <=
									0
								) {
									modalForm[key].value = 0;
								} else {
									modalForm[key].value = Number(
										this.signInfo.count +
										this.signInfo.surcharge_price +
										this.signInfo.outtimepay
									);
								}
							}
						}
						if (
							this.signInfo.count +
							this.signInfo.surcharge_price +
							this.signInfo.outtimepay <=
							0
						) {
							this.signInfo.sum = 0;
						} else {
							this.signInfo.sum =
								this.signInfo.count +
								this.signInfo.surcharge_price +
								this.signInfo.outtimepay;
						}
					}
				}
			}
		},
		
		handleModalSignClose() {
			let modalForm = this.modalForm;
			for (let key in modalForm) {
				modalForm[key].isChecked = false;
				modalForm[key].value = "";
			}
			this.form.discount_num = 0;
			this.checkAdditional = false;
			this.checkOutTimePay = false;
			this.checkOutDelivery = false;
			this.isPaying = false;
			this.infoSubmiting = false;
			this.showjuyy = false;
			this.isShowModalSign = false;
			clearTimeout(this.timeout);
			this.timeout = null;
			this.tiptext = "";
			this.juyyCode = "";
		},
		
		handleCanl(juyyCode) {
			console.log("取消聚应用支付");
			controller.abort();
			controller = new AbortController();
			
			clearInterval(this.setIntervalResult);
			this.setIntervalResult = null;
			// admin/icbc/cancel/payinfo  paymix_new_cancel
			console.log(this.isPaying, this.payResult);
			if (this.isPaying && this.payResult) {
				console.log("--------------------------退款");
				const token = localStorage.getItem("jyb_token");
				axios({
					url: this.$Api.paymix_new_cancel,
					method: "post",
					headers: {
						authorization: "Bearer " + token,
					},
					data: {
						CardNo: juyyCode,
					},
				});
				axios({
					url: this.$Api.paymix_new_refund,
					method: "post",
					headers: {
						authorization: "Bearer " + token,
					},
					data: {
						CardNo: juyyCode,
					},
				});
				axios({
					url: this.$Api.paymix_new_sanredo,
					method: "post",
					headers: {
						authorization: "Bearer " + token,
					},
					data: {
						CardNo: juyyCode,
					},
				});
			}
			this.isPaying = false;
			clearTimeout(this.timeout);
			this.timeout = null;
			this.payResult = true;
			this.closeJuyy();
			this.handleModalSignClose();
			this.getList();
		},
		
		closeJuyy() {
			clearInterval(this.setIntervalResult);
			this.setIntervalResult = null;
			this.showjuyy = false;
			this.infoSubmiting = false;
			this.juyyCode = "";
			this.tiptext = "";
			this.isShowModalSign = false;
		},
		
		timeOutResult() {
			this.timeout = setTimeout(() => {
				this.$Utils.showTipInfo("支付失败,请重新扫码");
				let audio = new Audio();
				audio.src = require("@/assets/audio/" + this.errorAudio);
				audio.play();
				
				if (this.payResult && this.isPaying) {
					this.handleCanl(this.juyyCode);
				}
				
				clearInterval(this.setIntervalResult);
				this.setIntervalResult = null;
				this.payResult = true;
				clearTimeout(this.timeout);
				this.timeout = null;
				this.infoSubmiting = false;
				this.juyyCode = "";
				this.tiptext = `支付失败,请重新扫码`;
				this.$refs?.juyy_ref?.focus();
			}, 20000);
		},
		
		getPayResult(data) {
			if (this.payResult) {
				return;
			}
			const token = localStorage.getItem("jyb_token");
			axios({
				url: this.$Api.paymix_new_result,
				method: "get",
				headers: {
					authorization: "Bearer " + token,
				},
				params: {
					CardNo: data.pay_code,
				},
			})
				.then((rep) => {
					const res = rep.data;
					if (res.code === 200201) {
						const status = res.data.data.status;
						if (status == "00") {
							this.payResult = true;
							this.updateOrderStatus(data);
							this.$Utils.showSuccess(res.msg);
							let audio = new Audio();
							audio.src = require("@/assets/audio/" + this.successAudio);
							audio.play();
							isthis.sums = 0;
							
							clearInterval(this.setIntervalResult);
							this.setIntervalResult = null;
							this.juyyCode = "";
							this.closeJuyy();
							this.handleModalSignClose();
							this.getList();
						}
					}
				})
				.catch((err) => {
					this.payResult = true;
					clearInterval(this.setIntervalResult);
					this.setIntervalResult = null;
					if (axios.isCancel(err)) {
						console.log("Request canceled", err.message);
					} else {
						this.$Utils.showTipInfo("支付失败");
						let audio = new Audio();
						audio.src = require("@/assets/audio/" + this.errorAudio);
						audio.play();
						
						this.isPaying = false;
						this.infoSubmiting = false;
						this.juyyCode = "";
						this.tiptext = "支付失败,请重新扫码";
						this.$refs?.juyy_ref?.focus();
					}
				});
		},
		
		updateOrderStatus(data) {
			const token = localStorage.getItem("jyb_token");
			axios({
				url: this.$Api.paymix_new_order,
				method: "post",
				headers: {
					authorization: "Bearer " + token,
				},
				data,
			})
				.then((rep) => {
				})
				.catch((err) => {
				});
		},
		
		change_juyy: $Utils.debounce(function (event) {
			const value = event.target.value;
			
			if (this.isPaying) {
				return false;
			}
			
			console.log("change:----", value);
			
			this.juyyCode = value.trim();
			this.infoSubmiting = true;
			
			if (this.juyyCode) {
				this.isPaying = true;
				this.tiptext = "掃描完成,支付中...";
				this.setIntervalResult = null;
				
				const phones = this.curCheckedList.map((item) => item.recipient_phone);
				const setPhone = new Set(phones);
				if (setPhone.size !== 1) {
					event.target.value = "";
					this.juyyCode = "";
					this.infoSubmiting = false;
					this.isPaying = false;
					this.tiptext = `只能簽收同一個用戶的快件`;
					console.log(this.juyyCode);
					return this.$message.warning("只能簽收同一個用戶的快件");
				}
				
				const token = localStorage.getItem("jyb_token");
				const userInfo = localStorage.getItem("jyb_logInfo")
					? JSON.parse(localStorage.getItem("jyb_logInfo"))
					: {};
				const modalForm = this.modalForm;
				const odd_numbers = this.curCheckedList.map((item, index) => {
					return item.odd_numbers;
				});
				const phone = this.curCheckedList[0].recipient_phone;
				const data = {
					/**
					 * "phone": "15626906056",
					 "orders": ["testmhn001"],
					 "amount": "2",
					 "pay_code": "21312123456151325", //支付codeed
					 "store_name": "123", //门店名称，AYDXXX，必须是这个格式
					 "outtineed": null, //是否免除超时费，ture免除
					 "freight_collect": null,//是否免除到付费，ture免除
					 "surcharge_price": null//是否免除附加费，ture免除
					 */
					phone,
					orders: odd_numbers,
					amount: Number(this.modalForm.juyy.value) || 0,
					// amount: 10,
					pay_code: this.juyyCode,
					store_name: userInfo.store_id,
					outtineed: this.checkOutTimePay,
					surcharge_price: this.checkAdditional,
					freight_collect: false,
				};
				console.log(data);
				this.payResult = false;
				axios({
					url: this.$Api.paymix_new2,
					method: "post",
					signal: controller.signal,
					headers: {
						authorization: "Bearer " + token,
					},
					data,
				})
					.then((rep) => {
						console.log(rep);
						const res = rep.data;
						this.isPaying = false;
						
						// this.timeOutResult();
						this.setIntervalResult = setInterval(
							() => this.getPayResult(data),
							1000
						);
						if (res.code === 200201) {
							this.payResult = true;
							this.$Utils.showSuccess(res.msg);
							let audio = new Audio();
							audio.src = require("@/assets/audio/" + this.successAudio);
							audio.play();
							isthis.sums = 0;
							
							this.updateOrderStatus(data);
							clearInterval(this.setIntervalResult);
							this.setIntervalResult = null;
							this.closeJuyy();
							this.handleModalSignClose();
							this.getList();
							this.juyyCode = "";
						} else {
							this.payResult = true;
							this.$Utils.showTipInfo(res.msg);
							let audio = new Audio();
							audio.src = require("@/assets/audio/" + this.errorAudio);
							audio.play();
							
							clearInterval(this.setIntervalResult);
							this.setIntervalResult = null;
							this.infoSubmiting = false;
							this.juyyCode = "";
							this.tiptext = `支付失败,请重新扫码,${res.msg}`;
							this.$refs?.juyy_ref?.focus();
						}
					})
					.catch((err) => {
						this.payResult = true;
						if (axios.isCancel(err)) {
							console.log("Request canceled", err.message);
							this.isPaying = true;
							this.handleCanl(data.pay_code);
						}
						clearInterval(this.setIntervalResult);
						this.setIntervalResult = null;
						clearTimeout(this.timeout);
						this.timeout = null;
						this.$Utils.showTipInfo("支付失败");
						let audio = new Audio();
						audio.src = require("@/assets/audio/" + this.errorAudio);
						audio.play();
						this.isPaying = false;
						this.infoSubmiting = false;
						this.juyyCode = "";
						this.tiptext = "支付失败,请重新扫码";
						this.$refs?.juyy_ref?.focus();
					});
			} else {
				this.tiptext = "请扫描支付码";
				this.$refs.juyy_ref.focus();
				this.infoSubmiting = false;
				this.isPaying = false;
			}
		}, 300),
		handlePay() {
			//确定付款
			this.isPaying = false;
			this.payResult = false;
			clearTimeout(this.timeout);
			clearInterval(this.setIntervalResult);
			this.infoSubmiting = true;
			//获取支付方式
			let modalForm = this.modalForm;
			let data = {};
			console.log(this.curCheckedList);
			let odd_numbers = this.curCheckedList.map((item, index) => {
				return item.odd_numbers;
			});
			
			// 判斷金額
			// console.log(this.signInfo.sum, (Number(this.modalForm.credit.value) + Number(this.modalForm.cash.value) + Number(this.modalForm.mPay.value) + Number(this.modalForm.juyy.value)))
			// if (this.signInfo.sum != (Number(this.modalForm.credit.value) + Number(this.modalForm.cash.value) + Number(this.modalForm.mPay.value) + Number(this.modalForm.juyy.value))) {
			// 	this.$Utils.showTipInfo('金額不匹配');
			// 	this.infoSubmiting = false;
			// 	return;
			// }
			
			data.odd_numbers = odd_numbers;
			data.outmany = this.checkOutTimePay; // 是否免超时费
			data.additional_fee = this.checkAdditional; // 是否免附加费
			
			if (Number(this.modalForm.delivery.value) > 0) {
				data.delivery = Number(this.modalForm.delivery.value);
				// console.log(data.delivery);
			}
			
			if (Number(this.modalForm.credit.value) > 0) {
				data.credit = Number(this.modalForm.credit.value);
				// console.log(data.credit);
			}
			if (Number(this.modalForm.cash.value) > 0) {
				data.cash = Number(this.modalForm.cash.value);
				// console.log(data.cash);
			}
			if (Number(this.modalForm.zyPos.value) > 0) {
				data.zyPos = Number(this.modalForm.zyPos.value);
				//console.log(data.zyPos);
			}
			if (Number(this.modalForm.mPay.value) > 0) {
				data.mPay = Number(this.modalForm.mPay.value);
				// console.log(data.mPay);
			}
			if (Number(this.modalForm.aomentong.value) > 0) {
				data.aomentong = Number(this.modalForm.aomentong.value);
				// console.log(data.aomentong);
			}
			if (Number(this.modalForm.alipay.value) > 0) {
				data.alipay = Number(this.modalForm.alipay.value);
				// console.log(data.alipay);
			}
			if (Number(this.modalForm.gyPos.value) > 0) {
				data.gyPos = Number(this.modalForm.gyPos.value);
				// console.log(data.gyPos);
			}
			if (Number(this.modalForm.wxpay.value) > 0) {
				data.wxpay = Number(this.modalForm.wxpay.value);
				// console.log(data.wxpay);
			}
			if (Number(this.modalForm.juyy.value) > 0) {
				data.juyy = Number(this.modalForm.juyy.value);
				// console.log(data.juyy);
				this.infoSubmiting = false;
				this.showjuyy = true;
				this.$nextTick(() => {
					this.$refs.juyy_ref.focus();
				});
				return false;
			}
			data.discount_num = this.form.discount_num || 0; // 是否免附加费
			console.log(data);
			
			this.isPaying = true;
			this.$Rq
				.requestAuth({
					url: this.$Api.paymix,
					method: "post",
					data: data,
				})
				.then((res) => {
					this.infoSubmiting = false;
					if (res.code === 0) {
						this.form.phone = "";
						this.$Utils.showSuccess(res.msg);
						let audio = new Audio();
						audio.src = require("@/assets/audio/" + this.successAudio);
						audio.play();
						this.isPaying = false;
						isthis.sums = 0;
						this.handleModalSignClose();
						this.getList();
					} else {
						this.$Modal.error({
							title: "警告",
							content: res.msg,
						});
						let audio = new Audio();
						audio.src = require("@/assets/audio/" + this.errorAudio);
						audio.play();
						this.isPaying = false;
						isthis.sums = 0;
					}
				})
				.catch((err) => {
					this.infoSubmiting = false;
				});
		},
		handlePay_jpoint() {
			//确定付款
			this.infoSubmiting = true;
			//获取支付方式
			let modalForm = this.modalForm;
			let data = {};
			let odd_numbers = this.curCheckedList.map((item, index) => {
				return item.odd_numbers;
			});
			
			// 判斷金額
			// if (this.signInfo.sum != (Number(this.modalForm.jpoint.value))) {
			// 	this.$Utils.showTipInfo('金額不匹配');
			// 	this.infoSubmiting = false;
			// 	return;
			// }
			this.isPaying = true;
			data.odd_numbers = odd_numbers;
			if (Number(this.modalForm.jpoint.value) > 0) {
				data.jpoint = Number(this.modalForm.jpoint.value);
				// console.log(data.delivery);
			}
			
			data.outmany = this.checkOutTimePay_jpoint; // 是否免超时费
			data.additional_fee = this.checkAdditional_jpoint; // 是否免附加费
			// console.log(data);
			
			this.$Rq
				.requestAuth({
					url: this.$Api.paymix,
					method: "post",
					data: data,
				})
				.then((res) => {
					this.infoSubmiting = false;
					if (res.code === 0) {
						this.form.phone = "";
						this.$Utils.showSuccess(res.msg);
						let audio = new Audio();
						audio.src = require("@/assets/audio/" + this.successAudio);
						audio.play();
						this.isPaying = false;
						isthis.sums = 0;
						this.handleModalSignClose_jpoint();
						this.getList();
					} else {
						this.$Modal.error({
							title: "警告",
							content: res.msg,
						});
						let audio = new Audio();
						audio.src = require("@/assets/audio/" + this.errorAudio);
						audio.play();
						this.isPaying = false;
						isthis.sums = 0;
					}
				})
				.catch((err) => {
					this.infoSubmiting = false;
				});
		},
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			isthis.sums = 0;
			this.getList();
		},
		handlePageInput() {
			let value = ("" + this.pageInput).replace(/\D/g, "");
			let pageCount = Math.floor(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			isthis.sums = 0;
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			isthis.sums = 0;
			this.getList();
		},
		handlePageChange(value) {
			this.pageIndex = value;
			isthis.sums = 0;
			this.getList();
		},
		handleSelectionChange() {
			let sums = 0;
			this.curCheckedList = this.$refs.table.getSelection();
			this.curCheckedList.forEach((item) => {
				if (item.pay_type == "未在APP內付款") {
					sums += item.sum;
				} else {
					sums += item.outtimepay;
				}
			});
			isthis.sums = Number(sums);
		},
		handlePageInput_No_Shelf() {
			let value = ("" + this.pageInput_No_Shelf).replace(/\D/g, "");
			let pageCount = Math.floor(
				this.totalCount_No_Shelf / this.curPageSize_No_Shelf
			);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput_No_Shelf = value;
		},
		handlePageEnter_No_Shelf() {
			if (
				this.pageInput_No_Shelf == "" ||
				this.pageInput_No_Shelf == this.pageIndex_No_Shelf
			)
				return;
			if (this.pageInput_No_Shelf == 0) {
				this.pageInput_No_Shelf = 1;
			}
			this.pageInput_No_Shelf = parseInt(this.pageInput_No_Shelf);
			this.pageIndex_No_Shelf = this.pageInput_No_Shelf;
			this.getnoshelfList();
		},
		handlePageSizeChange_No_Shelf(value) {
			this.pageIndex_No_Shelf = 1;
			this.getnoshelfList();
		},
		handlePageChange_No_Shelf(value) {
			this.pageIndex_No_Shelf = value;
			this.getnoshelfList();
		},
	},
};
</script>

<style lang="scss" scoped>
@import "SignTodo.scss";
</style>
<style>
.ivu-table td.demo-table-info-column {
	background-color: #ffebde;
	color: #000;
}

.ivu-table td.demo-table-info-cell-name {
	background-color: #d6e7ff;
	color: #515a6e;
}

.ivu-table td.demo-table-info-cell-name-sum {
	background-color: #ffebde;
	color: #000;
}

.ivu-table .demo-table-error-row {
	background-color: #fcffd6;
	color: #515a6e;
}

.ivu-table .demo-table-info-row {
	background-color: #ffebde;
	color: #515a6e;
}

.ivu-table .demo-table-app-row {
	background-color: #e8ffd6;
	color: #515a6e;
}
</style>
